/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-script-url*/
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Tooltip, Modal, DatePicker, message } from "antd";
import Button from "../../common/button";
import { Button as _Button } from 'antd';
import OrganisationService from "../../../../services/organisation/organisationService";
import "./summary.less";
import { ActiveImg, BranchIcon, UsersIcon, forwardArrowImg } from "../../../../images";
import DevicesIcon from '../../../../../assets/images/DevicesIcon.svg'
import { organisationDetailsSelector } from "../../../../../redux/reducers/organisation/organisationDetailsReducer";
import { AppRoutes } from "../../../../constants/enums";
import { ProfileThumbnailPicture } from "../../user/profile/profileThumbnailPicture";
import { AvatarColorList, PortalType, PortalTypeKey, jsonData } from "../../../../constants/constants";
import { getUserRoles } from "../../../../../utility/appUtil";
import { UserRole } from "../../../../constants/enums";
import { userStateSelector } from "../../../../../redux/reducers/user/userReducer";
import { CompWrapper } from "../../common/compWrapper/compWrapper";
import { settingsEntered } from "../../../../../redux/actions/app/appAction";
import { useTranslation } from 'react-i18next';

const OrganisationSummary = (props: any) => {
  const { t } = useTranslation()
  const { organisation, locations, users, devices } = useSelector(organisationDetailsSelector);
  const { onChangeTab } = props;
  const { appUser } = useSelector(userStateSelector);
  const dispatch = useDispatch()
  
  // State for migrate popup
  const [isMigrateModalVisible, setIsMigrateModalVisible] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const organisationService = new OrganisationService();

  const editOrganisation = () => {
    onChangeTab("2");
  };
  const editSubscription = () => {
    onChangeTab("3");
  };

  const openNewTab = (loc: string = '') => {
    let url = '';
    switch (loc) {
      case 'locations':
        dispatch(settingsEntered({ path: AppRoutes.USER_DASHBOARD, isSettingState: true }))
        url = `${AppRoutes.ORGANISATION_LOCATIONS}?${PortalTypeKey.CLIENT_PORTAL}=${PortalType.CLIENT_PORTAL}&oid=${organisation?.result?.id}`;
        break;

      case 'users':
        dispatch(settingsEntered({ path: AppRoutes.USER_DASHBOARD, isSettingState: true }))
        url = `${AppRoutes.USER_LIST}?${PortalTypeKey.CLIENT_PORTAL}=${PortalType.CLIENT_PORTAL}&oid=${organisation?.result?.id}`;
        break;

      case 'devices':
        dispatch(settingsEntered({ path: AppRoutes.USER_DASHBOARD, isSettingState: true }))
        url = `${AppRoutes.DEVICE_SETTINGS}?${PortalTypeKey.CLIENT_PORTAL}=${PortalType.CLIENT_PORTAL}&oid=${organisation?.result?.id}`;
        break;  
    }
    const win = window.open(url, "_blank");
    if (win !== null) {
      win.focus();
    }
  };

  const isSubscriptionEditingAllowed = () => {
    let role: any[] = [];
    if (appUser) role = getUserRoles(appUser);
    if (role.includes(UserRole.BIBLIOTHECA_USER)) {
      return false;
    }
    return true;
  }

  const isPlatformAdmin = () => {
    return appUser?.locations?.[0]?.role?.name === UserRole.PLATFORM_ADMIN;
  };

  // Migrate functionality
  const showMigrateModal = () => {
    setIsMigrateModalVisible(true);
    setStartDate(null); // Reset start date
    setEndDate(null); // Reset end date
  };

  const handleMigrateOk = async () => {
    if (!startDate) {
      message.error('Please select a start date');
      return;
    }
    
    if (!endDate) {
      message.error('Please select an end date');
      return;
    }
    
    // Validate that start date is less than end date
    if (startDate.isSameOrAfter(endDate)) {
      message.error('Start date must be less than end date');
      return;
    }
    
    // Format dates to required format (YYYY-MM-DD)
    const formattedStartDate = startDate.format('YYYY-MM-DD');
    const formattedEndDate = endDate.format('YYYY-MM-DD');
    
    try {
      // Show loading message
      const loadingMessage = message.loading('Initiating migration...', 0);
      
      // Call migration API
      const response = await organisationService.migrateOrganisation(
        organisation?.result?.id,
        formattedStartDate,
        formattedEndDate
      );
      
      // Hide loading message
      loadingMessage();
      
      // Close modal and reset state
      setIsMigrateModalVisible(false);
      setStartDate(null);
      setEndDate(null);
      
      // Handle success response
      if (response.status === 'success') {
        message.success(response.result.message || `Migration initiated successfully for ${organisation?.result?.name}`);
      } else {
        message.error('Migration failed: Unexpected response format');
      }
      
    } catch (error: any) {
      // Hide loading message if still showing
      message.destroy();
      // Handle error response - check different possible error structures
      let errorMessage = 'Migration failed: An unexpected error occurred';
      
      if (error?.response?.data) {
        const errorData = error.response.data;
        
        // Check if it's the API error format: { status: "error", error: { message: "..." } }
        if (errorData.status === 'error' && errorData.error?.message) {
          errorMessage = errorData.error.message;
        }
        // Check if error message is directly in the response
        else if (errorData.message) {
          errorMessage = errorData.message;
        }
        // Check if there's a result with error message
        else if (errorData.result?.message) {
          errorMessage = errorData.result.message;
        }
      }
      // Check if error has a direct message
      else if (error?.message) {
        errorMessage = `Migration failed: ${error.message}`;
      }
      
      message.error(errorMessage);
    }
  };

  const handleMigrateCancel = () => {
    setIsMigrateModalVisible(false);
    setStartDate(null); // Reset start date
    setEndDate(null); // Reset end date
  };

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
    // Clear end date if it's before or same as the new start date
    if (endDate && date && endDate.isSameOrBefore(date)) {
      setEndDate(null);
      message.warning('End date cleared because it must be after the start date');
    }
  };

  const handleEndDateChange = (date: any) => {
    // Validate that end date is after start date
    if (startDate && date && date.isSameOrBefore(startDate)) {
      message.error('End date must be after start date');
      return;
    }
    setEndDate(date);
  };
  
  return (
    <div>
      <CompWrapper otherClasses="ant-row pl-vw scrollSummary">
        <Col span={16}>
          <div className="summary-container">
            <div className="summary-subcontainer">
              <ProfileThumbnailPicture src={organisation?.result?.info?.logo} firstName={organisation?.result?.name?.split(' ')?.[0] || ''} lastName={organisation?.result?.name?.split(' ')?.[1] || ''} colors={AvatarColorList} round={true} size="35" />
            </div>
            <span className="organisation-title">{organisation?.result?.shortName}</span>
            <span className="other-details mb-8">{organisation?.result?.name}</span>
            <p>
              <a tabIndex={-1} className="website" href={(organisation?.result?.info?.website?.includes("http")) ? organisation?.result?.info?.website : `https://${organisation?.result?.info?.website}`} target="_blank">{organisation?.result?.info?.website}</a>
            </p>
            <span className="other-details mt-36">
              {[organisation?.result?.postalAddress?.line1, organisation?.result?.info?.locality, organisation?.result?.postalAddress?.line2, organisation?.result?.postalAddress?.line3, organisation?.result?.postalAddress?.line4].filter(item => item?.trim() !== '').join(', ')}
            </span>
            <span className="other-details">
              {[organisation?.result?.postalAddress?.postcode, organisation?.result?.postalAddress?.county === 'Add County/Region' ? '' : organisation?.result?.postalAddress?.county,organisation?.result?.postalAddress?.country].filter(item => item?.trim() !== '').join(', ')},
              
            </span>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Edit)}>
                <div className="edit-button" onKeyPress={editOrganisation}  >
                  <Button
                    type="smallBlack fs-12 btnCommon"
                    onClick={editOrganisation}
                    tabIndex={0}
                    ariaLabel={""} 
                    role={""}
                  >
                    {t(jsonData.Edit)}
                  </Button>
                </div>
              </Tooltip>
              {isPlatformAdmin() && (
                <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title="Migrate organisation data">
                  <div className="edit-button" onKeyPress={() => showMigrateModal()}>
                    <Button
                      type="smallBlack fs-12 btnCommon"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        showMigrateModal();
                      }}
                      tabIndex={0}
                      ariaLabel="Migrate organisation data"
                      role="button"
                    >
                      Migrate
                    </Button>
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        </Col>
        <Col span={8}>
          {/* <div className="secondary-container" >
            <h3 className="subscriptionHeading">Subscription</h3>
            <p className="activeSub mb-0">{organisation?.result?.isActive ? <><img src={ActiveImg} alt="" />Active</> : "Inactive"}</p>
            {isSubscriptionEditingAllowed() ?
              <Col className="subscription-edit-button" md={24} lg={12}>
                <Button
                  type="smallBlack fs-12"
                  onClick={editSubscription}
                >
                  Edit
                </Button>
              </Col>
              : null}
          </div> */}
          <div className="secondary-container tertiaryContainer">
            <Row className="orgSummaryInfo">
              <Col  md={15} lg={17} xl={18}>
                <p className="specific-details mb-0"><img className="redi-icons" src={BranchIcon} alt="locations" />
                  <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Locations)}>
                    <span className="basicInfoEllipsis">{t(jsonData.Locations)}</span>
                  </Tooltip>
                </p>
              </Col>
              <Col md={6} lg={4} xl={3}>
                <p className="specific-details-number mb-0">{typeof locations == 'object' ? 0 : locations}</p>
              </Col>
              <Col span={3} onKeyPress={() => { openNewTab('locations') }}>
                {/* <Link to={{ pathname: '/organisation/locations', state: { organisationID: props.id } }} className="redi-button"> */}
                <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Locations)}>
                  <_Button type="link" tabIndex={0} aria-label={t(jsonData.Locations)} role={"link"} size="small" className="forwardBtn redi-button" onClick={() => { openNewTab('locations') }}>
                    <img className="forwardArrowBtn" src={forwardArrowImg} alt="" />
                  </_Button>
                  </Tooltip>
                {/* </Link> */}
              </Col>
            </Row>
            <Row className="orgSummaryInfor">
              <Col md={15} lg={17} xl={18}>
                <p className="specific-details mb-0"><img className="redi-icons" src={UsersIcon} alt="users" />
                  <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Users)}>
                    <span className="basicInfoEllipsis">{t(jsonData.Users)}</span>
                  </Tooltip>
                </p>
              </Col>
              <Col md={6} lg={4} xl={3}>
                <p className="specific-details-number mb-0">{typeof users == 'object' ? 0 : users}</p>
              </Col>
              <Col span={3} onKeyPress={() => { openNewTab('users') }}>
                {/* <Link to={{ pathname: AppRoutes.USER_LIST }} className="redi-button"> */}
                <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Users)}>
                  <_Button tabIndex={0} aria-label={t(jsonData.Users)} role={"link"} type="link" size="small" className="forwardBtn redi-button" onClick={() => { openNewTab('users') }}>
                    <img className="forwardArrowBtn" src={forwardArrowImg} alt="" />
                  </_Button>
                  </Tooltip>
                {/* </Link> */}
              </Col>
            </Row>
            <Row>
              <Col md={15} lg={17} xl={18}>
                <p className="specific-details mb-0"><img className="redi-icons" src={DevicesIcon} alt="devices" />
                  <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Devices)}>
                    <span className="basicInfoEllipsis">{t(jsonData.Devices)}</span>
                  </Tooltip>
                </p>
              </Col>
              <Col md={6} lg={4} xl={3}>
                <p className="specific-details-number mb-0">{typeof devices == 'object' ? 0 : devices}</p>
              </Col>
              <Col span={3}  onKeyPress={() => { openNewTab('devices') }}>
                {/* <Link to={{ pathname: '/organisation/devices' }} className="redi-button"> */}
                <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.Devices)}>
                  <_Button tabIndex={0} aria-label={t(jsonData.Devices)} role={"link"} type="link" size="small" className="forwardBtn redi-button" onClick={() => { openNewTab('devices') }}>
                    <img className="forwardArrowBtn" src={forwardArrowImg} alt="" />
                  </_Button>
                  </Tooltip>
                {/* </Link> */}
              </Col>
            </Row>
          </div>
        </Col>
      </CompWrapper>
      
      {/* Migrate Modal */}
      <Modal
        title={`Migrate Organisation - ${organisation?.result?.name}`}
        visible={isMigrateModalVisible}
        onOk={handleMigrateOk}
        onCancel={handleMigrateCancel}
        okText="OK"
        cancelText="Cancel"
        width={650}
        centered
      >
        {/* Date Range Selection */}
        <div style={{ marginBottom: '16px' }}>
          <Row gutter={16}>
            <Col span={12}>
              <label htmlFor="startDatePicker" style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Start Date <span style={{ color: 'red' }}>*</span>
              </label>
              <DatePicker
                id="startDatePicker"
                placeholder="Select start date"
                style={{ width: '100%' }}
                value={startDate}
                onChange={handleStartDateChange}
                format="YYYY-MM-DD"
                size="large"
                className="migrateDatePicker"
              />
            </Col>
            <Col span={12}>
              <label htmlFor="endDatePicker" style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                End Date <span style={{ color: 'red' }}>*</span>
              </label>
              <DatePicker
                id="endDatePicker"
                placeholder="Select end date"
                style={{ width: '100%' }}
                value={endDate}
                onChange={handleEndDateChange}
                format="YYYY-MM-DD"
                size="large"
                className="migrateDatePicker"
                disabledDate={(current) => {
                  // Disable dates before or same as start date
                  return startDate && current && current.isSameOrBefore(startDate, 'day');
                }}
              />
            </Col>
          </Row>
        </div>

        <div style={{ fontSize: '12px', color: '#666' }}>
          Please select the date range for data migration.
        </div>
      </Modal>
    </div>
  );
};
export default OrganisationSummary;
